import { MessageTypes } from '@allie/mfe';

export enum ErrorCodes {
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHENTICATED_ERROR = 'UNAUTHENTICATED',
}

export enum OperationNames {
}

export const ErrorMessagesByCode: Record<ErrorCodes, { title: string; type: MessageTypes }> = {
  [ErrorCodes.NETWORK_ERROR]: {
    title: 'NETWORK_ERROR',
    type: MessageTypes.ERROR,
  },
  [ErrorCodes.UNKNOWN_ERROR]: {
    title: 'UNKNOWN_ERROR',
    type: MessageTypes.ERROR,
  },
  [ErrorCodes.UNAUTHENTICATED_ERROR]: {
    title: 'UNAUTHENTICATED_ERROR',
    type: MessageTypes.ERROR,
  },
};

export const ErrorMessagesByOperation: Record<
  OperationNames,
  { title: string; type: MessageTypes }
> = {
};
